<template>
    <div class="eventApplicationModal">
        <div class="header header-complete u-text-center">
            <div class="status">
                <template v-if="isReservoir">リザーバー応募受付完了</template>
                <template v-else-if="isArrivingFirst">先着応募受付完了</template>
                <template v-else-if="isDrawing">抽選応募受付完了</template>
            </div>
            <div class="c-title c-title-page u-mb">
                応募が完了しました！
            </div>
            <p class="under-title">結果は、マイページ内「出場予定のイベント」で確認できます。</p>
            <div class="c-warningBox" v-if="eventData.eventTypeId !== 7 && eventData.deckRegistFlg === 1">
                <p v-if="!isDrawing">参加が確定していなくても、デッキの登録が可能です。</p>
                <p><span v-if="isDrawing">当選後、</span><span class="u-text-bold">{{ dataFormat(this.eventData.deckRegistEndedAt, 3) }}</span>までにデッキを登録してください。</p>
            </div>
        </div>
        <p class="u-mb u-text-center">登録されているメールアドレスにメールをお送りしました。</p>
        <div class="mailaddress u-mb-lg">
            <p>送信したメールアドレス</p>
            <div class="mail">
                {{ sendMailAddress }}
            </div>
        </div>
        <template v-if="eventData.priorityFlg === 1 && !isAdditionalEntry">
            <div class="priorityText-complete">
                <span class="title">「第1希望」について</span>
                <p class="u-mb">「第1希望」を「ON」にしたエントリーは、自分が応募しているその他のエントリーよりも優先して当選しやすくなります。</p>
                <p>各シーズンごとのシティリーグなど、複数の会場で行われる同じ種類のイベントへの抽選応募時に、設定できます。</p>
                <p>抽選応募受付中であれば、マイページの「出場予定のイベント」から、いつでも「第1希望」の設定を変更することが可能です。</p>
            </div>
        </template>
        <div class="u-text-center to-mypage">
            <router-link
                :to="{name: 'Mypage'}"
                class="c-btn c-btn-primary-outline sp-width-100"
            >
                マイページへ
            </router-link>
        </div>
    </div>
</template>

<script>
import stateData from '../../methods/data.js'

export default {
    mixins: [stateData],
    props: {
        eventData: {
            type: Object,
            default() {
                return {}
            }
        },
        isArrivingFirst: {
            type: Boolean,
            default: false,
        },
        isDrawing: {
            type: Boolean,
            default: false,
        },
        isReservoir: {
            type: Boolean,
            default: false,
        },
        isAdditionalEntry: {
            type: Boolean,
            default: false,
        },
        sendMailAddress: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
        }
    },
    computed: {},
    created: function() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
@use '../../style/applicationModal';
</style>
